import { Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { AlertService } from '../services/alert.service';
import { Router } from '@angular/router';
import { MenumobileComponent } from './menumobile.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input() public UserName: string;
  @Output() public open = new EventEmitter();
  public logo: string;
  public site: string;
  constructor(private userService: UserService, private sessionService: SessionService,
    private alertService: AlertService, private router: Router) {
}

  ngOnInit() {
        this.logo = environment.logo;
        this.site = environment.site;
    }

    public logout() {
              this.sessionService.logout();
              this.router.navigate(['public/login']);
          }

    public  lanzar(event) {
        MenumobileComponent.changeContrato.next(true);
        this.open.emit({abrir: true});
    }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/header.component.ts